import moment from "moment"
import { cellValueExcel, RowExportTypeExcel } from "types"
import { excel } from "utils"
import { FormType, getDifference } from "../utils"
import { useOptionalCountDetailContext } from "../contexts"
import { PropsWithChildren } from "react"

type ExportExcelCountInventoryProps = {
  countdetail: FormType["countdetail"]
  transaction_date: FormType["transaction_date"]
  getCountDetail: ReturnType<typeof useOptionalCountDetailContext>
}

export function ExportExcelCountInventory(params: PropsWithChildren<ExportExcelCountInventoryProps>) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "ITEM", key: "product_barcode", width: 20 },
    { header: "DESCRIPTION", key: "product_name", width: 30 },
    { header: "UNIT", key: "mr_unit_name", width: 15 },
    { header: "SOH", key: "soh_count", width: 15 },
    { header: "COUNT", key: "real_count", width: 15 },
    { header: "DIFFERENT", key: "different", width: 15 }
  ]

  const dataMap: RowExportTypeExcel[] = params?.countdetail?.map((item, index) => {
    const dataCount = params?.getCountDetail?.data?.countdetail?.find((i) => i?.product_id === item?.product_id)

    return {
      no: index + 1,
      product_barcode: dataCount?.product_barcode || "-",
      product_name: dataCount?.product_name || "-",
      mr_unit_name: dataCount?.mr_unit_name || "-",
      soh_count: numberFormat(item?.soh_count),
      real_count: numberFormat(item?.real_count),
      different: numberFormat(getDifference(item?.soh_count, item?.real_count))
    }
  })

  excel({
    dataList: dataMap,
    column: columns,
    title: "COUNT INVENTORY ITEM", 
    module: "INVENTORY", 
    fileName: "count_inventory_item",
    date: `${moment(params?.transaction_date).format('DD-MM-YYYY')}`
  })
}

function numberFormat(value: number): cellValueExcel {
  return {
    text: value,
    style: {
      alignment: { horizontal: "right" },
      numFmt: "#,##0"
    }
  }
}